import apiAxios from '@/apiAxios.js'
import { jsPopSelectUser } from '@/ASysUtil/sysUtil.js'
import { cloneDeep } from '@/common/util/cloneDeep.js'
import { tabManagerBus } from '@/common/globalBus.js'
import 'viewerjs/dist/viewer.css'

export default {
  components: {},
  props: ['modesTaskData'],
  data() {
    return {
      show: false,
      pickerOptions2: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      tableData1: [],
      options: {
        inline: true,
        button: true,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
      },
      images: [],
      imageData: [],
      form: {
        edocNo: '',
        edocType: '',
        edocImageType: '',
        id: '',
        // code: '',
        invCode: '',
        invNo: '',
        invDate: '',
        // price: 0,
        invAmount: 0,
        // tax: 0,
        invTax: 0,
        total: 0,
        kind: '',
        type: '',
        priceSum: 0,
        taxSum: 0,
        totalSum: 0,
        salerName: '',
        salerTaxCode: '',
        buyerName: '',
        buyerTaxCode: '',
        machineCode: '',
        checkCode: '',
      },
      processType: '', //文件类型入参
      tableData2: [], //模式二列表页
      headForm: {
        //模式二表头
        edocNo: '',
        edocType: '',
        seal: '',
        review: '',
        createBy: '',
        imageState: '',
        collectionFrom: '',
        makeEdocNumber: '',
        createTimeStr: '',
        edocTaskStatus: '',
      },
      parameter: {},
      parameter2: {},
      parameter3: {},
      fileList1: [],
      fileList2: [],
      fileList3: [],
      multipleInvoices: [],
      papperList: [],
      bizTypeList: [],
      classIndex: 0,
      imageIndex: 0,
      curPage: 1,
      genPage: 0,
      endPage: 0,
      taskId: '',
      queryParams: {
        limit: 10,
        page: 1,
      },
      queryResult: {
        totalElements: 0,
        totalPages: '',
      },
      imageTypeConfig: {
        invMoneyTotal: false,
        invoicesButton: false,
        invoicesForm: false,
      },

      imagesUrl: [], //模式三图片
      viewer: '',
      isLoading: false,
      dialogVisible: false,
      dialogVisible2: false,

      modeFour: false,
      tableDatalist: [], //模式四列表页
      watchVisible: false, //详情
      activeName2: 'first',
      dialogTableData: [],
      imgUrl: '',
      editItem: {
        //详情数据
        invCode: '',
        invNo: '',
        invType: '',
        invDate: '',
        invAmount: '',
        invTax: '',
        buyerName: '',
        buyerTaxCode: '',
        salerName: '',
        salerTaxCode: '',
        remark: '',
        checkReal: '',
        checkDetails: '',
        extField2: '',
        checkTime: '',
      },
      invDetail: [],
      disUpload: false,
      canEdit: true,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      textarea: '',
      pageTure: {
        viewImagePage: null, //默认显示第一批
        viewImageLimit: null, //每批显示图片数量
      },
      viewByPage: false, //是否超出30页
    }
  },
  watch: {
    modesTaskData: {
      async handler(newValue, oldValue) {
        if (newValue.bizName == '合同存档' || newValue.bizName == '资料存档') {
          this.modeFour = false
        } else {
          this.modeFour = true
        }
        await this.papperStatus()
        await this.bizType()
        await this.setImages()
        // await this.tabdata()
        await this.footdata()
        await this.invoiceData()
        await this.tabdata()
      },
    },
    headForm: {
      async handler(newValue, oldValue) {
        if (newValue.seal == '已封单') {
          this.disUpload = true
        } else {
          this.disUpload = false
        }
      },
    },
  },
  computed: {},
  methods: {
    //前三十页
    pageprev() {
      if (this.pageTure.viewImagePage > 1) {
        this.pageTure.viewImagePage--
        this.setImages()
        this.curPage =
          (this.pageTure.viewImagePage - 1) * this.pageTure.viewImageLimit + 1
        this.endPage =
          this.pageTure.viewImagePage * this.pageTure.viewImageLimit
      } else {
        this.$message({
          showClose: true,
          message: '当前已经是第一页了!',
          type: 'error',
        })
      }
    },
    //后三十页
    pagenext() {
      if (
        this.pageTure.viewImagePage <
        Math.ceil(this.genPage / this.pageTure.viewImageLimit)
      ) {
        this.pageTure.viewImagePage++
        this.setImages()
        this.curPage =
          (this.pageTure.viewImagePage - 1) * this.pageTure.viewImageLimit + 1
        if (
          this.pageTure.viewImagePage * this.pageTure.viewImageLimit >
          this.genPage
        ) {
          this.endPage = this.genPage
        } else {
          this.endPage =
            this.pageTure.viewImagePage * this.pageTure.viewImageLimit
        }
      } else {
        this.$message({
          showClose: true,
          message: '后面没有啦!',
          type: 'error',
        })
      }
    },
    //文件类型下拉框值改变
    async change(params, val) {
      if (val == 'EVAT_N_E_INV' || val == 'VAT_N_INV' || val == 'VAT_S_INV') {
        this.imageTypeConfig.invMoneyTotal = false
        this.imageTypeConfig.invoicesButton = false
        this.imageTypeConfig.invoicesForm = true
      } else {
        this.imageTypeConfig.invoicesForm = false
        this.imageTypeConfig.invMoneyTotal = false
        this.imageTypeConfig.invoicesButton = false
      }
    },
    //单张删除
    async oneDelete() {
      this.$confirm('您确认删除吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger',
      }).then(
        async () => {
          let imgId = this.images[this.imageIndex].id
          const { data } = await apiAxios.post(
            `/edoc/edocImageFacade/deleteBillImageById`,
            {
              imageId: imgId,
            }
          )
          if (data.success == true) {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'success',
            })
            this.curPage = 1
            // this.imageIndex = 0
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error',
            })
          }
          this.pageTure.viewImagePage = 1
          await this.setImages()
          await this.footdata()
        },
        () => {}
      )
    },

    //转变字符类型
    isString(value) {
      return typeof value === 'string'
    },
    //获取图片名字
    getImageNameFromURL(url) {
      return this.isString(url)
        ? url.replace(/^.*\//, '').replace(/[?&#].*$/, '')
        : ''
    },
    //单张下载
    toDown() {
      let imgPath = this.images[this.imageIndex].path
      const imgName = this.getImageNameFromURL(imgPath)
      const alink = document.createElement('a') //不跨域下载图片
      alink.href = imgPath
      alink.download = imgName //图片名
      alink.click()
    },
    //批量下载
    async batchDown() {
      for (var i = 0; i < this.images.length; i++) {
        let imgPath = this.images[i].path
        const imgName = this.getImageNameFromURL(imgPath)
        const alink = document.createElement('a')
        alink.href = imgPath
        alink.download = imgName //图片名
        await new Promise(function(resolve) {
          setTimeout(resolve, 100)
        })
        alink.click()
      }
    },
    //打印
    toPrint(type) {
      let imageHtml = ''
      if (type == 1) {
        imageHtml =
          '<img src="' +
          this.images[this.imageIndex].path +
          '" style="width:100%"/>'
      } else {
        for (var i = 0; i < this.images.length; i++) {
          imageHtml +=
            '<img src="' + this.images[i].path + '" style="width:100%"/>'
        }
      }
      var f = document.getElementById('printf')
      f.contentDocument.write(imageHtml)
      f.contentDocument.close()
      f.contentWindow.print()
    },

    //补采集
    async oneCollect() {
      this.dialogVisible1 = true
    },
    async commintOneAction() {
      this.dialogVisible1 = false
      if (this.textarea) {
        let state = this.modesTaskData
        const coverId = state.coverId.toString()
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') },
          { reviewMessage: this.textarea },
          { reviewStatus: '3' },
          { reviewSource: '1' }
        )
        const { data } = await apiAxios.post(
          `/edoc/edocImageFacade/scrapByTaskId`,
          genList
        )
        if (data.success) {
          this.$alert(data.msg, '操作提示', {
            confirmButtonText: '确定',
          })
        } else {
          this.$alert(data.msg, '评价失败', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('评价信息不能为空，请重新评价', '评价失败', {
          confirmButtonText: '确定',
        })
      }
      this.textarea = ''
    },
    //整单重采集
    async allCollect() {
      this.dialogVisible2 = true
    },
    async commintTwoAction() {
      this.dialogVisible2 = false
      if (this.textarea) {
        let state = this.modesTaskData
        const coverId = state.coverId.toString()
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') },
          { reviewMessage: this.textarea },
          { reviewStatus: '2' },
          { reviewSource: '1' }
        )
        const { data } = await apiAxios.post(
          `/edoc/edocImageFacade/scrapByTaskId`,
          genList
        )
        if (data.success) {
          this.$alert(data.msg, '操作提示', {
            confirmButtonText: '确定',
          })
        } else {
          this.$alert(data.msg, '评价失败', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('评价信息不能为空，请重新评价', '评价失败', {
          confirmButtonText: '确定',
        })
      }
      this.textarea = ''
    },
    //整单作废
    async allVoid() {
      this.dialogVisible3 = true
    },
    async commintThreeAction() {
      this.dialogVisible3 = false
      if (this.textarea) {
        let state = this.modesTaskData
        const coverId = state.coverId.toString()
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') },
          { reviewMessage: this.textarea },
          { reviewStatus: '1' },
          { reviewSource: '1' }
        )
        const { data } = await apiAxios.post(
          `/edoc/edocImageFacade/scrapByTaskId`,
          genList
        )
        if (data.success) {
          this.$alert(data.msg, '操作提示', {
            confirmButtonText: '确定',
          })
        } else {
          this.$alert(data.msg, '评价失败', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('评价信息不能为空，请重新评价', '评价失败', {
          confirmButtonText: '确定',
        })
      }
      this.textarea = ''
    },
    //数据不完整
    async incomplete() {
      this.dialogVisible4 = true
    },
    async commintFourAction() {
      this.dialogVisible4 = false
      if (this.textarea) {
        let state = this.modesTaskData
        const coverId = state.coverId.toString()
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') },
          { reviewMessage: this.textarea },
          { reviewStatus: '4' },
          { reviewSource: '1' }
        )
        const { data } = await apiAxios.post(
          `/edoc/edocImageFacade/scrapByTaskId`,
          genList
        )
        if (data.success) {
          this.$alert(data.msg, '操作提示', {
            confirmButtonText: '确定',
          })
        } else {
          this.$alert(data.msg, '评价失败', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('评价信息不能为空，请重新评价', '评价失败', {
          confirmButtonText: '确定',
        })
      }
      this.textarea = ''
    },

    inited(viewer) {
      this.$viewer = viewer
    },
    addInvoices() {
      //新增多发票
      const invoicesData = {
        id: '',
        tabName: '新增',
        code: '',
        invNo: '',
        invDate: '',
        price: 0,
        tax: 0,
        total: 0,
        kind: '',
        type: '',
        seller: '',
        sellerCode: '',
        sellerPhone: '',
        sellerAccount: '',
        buyer: '',
        buyerCode: '',
        buyerPhone: '',
        buyerAccount: '',
        machineCode: '',
        cipher: '',
        checkCode: '',
      }
      this.multipleInvoices.push(invoicesData)
      for (const key in invoicesData) {
        this.form[key] = invoicesData[key]
      }
      this.classIndex = this.multipleInvoices.length - 1
    },
    //上一张
    prev() {
      this.$viewer.prev()
      this.imageSwitch(this.$viewer)
      if (this.viewByPage) {
        this.curPage =
          (this.pageTure.viewImagePage - 1) * this.pageTure.viewImageLimit +
          this.imageIndex +
          1
      } else {
        this.curPage = this.imageIndex + 1
      }
      this.toSetTaskDetails()
      this.canEdit = true
    },
    //下一张
    next() {
      this.$viewer.next()
      this.imageSwitch(this.$viewer)
      if (this.viewByPage) {
        this.curPage =
          (this.pageTure.viewImagePage - 1) * this.pageTure.viewImageLimit +
          this.imageIndex +
          1
      } else {
        this.curPage = this.imageIndex + 1
      }
      this.toSetTaskDetails()
      this.canEdit = true
    },
    changeInvoices(index) {
      alert(0)
      this.classIndex = index
      for (const key in this.multipleInvoices[index]) {
        this.form[key] = this.multipleInvoices[index][key]
      }
    },
    imageSwitch(e) {
      let wrapper = document.getElementsByClassName('viewer-wrapper')[0]
      let list = wrapper.getElementsByClassName('viewer-list')[0].childNodes
      let index = 0
      for (var i = 0; i < list.length; i++) {
        if (list[i].className == 'viewer-active') {
          this.imageIndex = i
        }
      }
      // this.toSetTaskDetails()
    },
    //渲染数据
    async toSetTaskDetails() {
      let docId = this.images[this.imageIndex].docId
      let result = this.imageData[this.imageIndex]
      if (result && docId) {
        //根据文件种类显示不同的区域
        if (
          docId == 'EVAT_N_E_INV' ||
          docId == 'VAT_N_INV' ||
          docId == 'VAT_S_INV'
        ) {
          this.imageTypeConfig.invMoneyTotal = false
          this.imageTypeConfig.invoicesButton = false
          this.imageTypeConfig.invoicesForm = true
          if (result[0].invoiceItemModelList) {
            this.tableData1 = result[0].invoiceItemModelList
          } else {
            this.tableData1 = []
          }
        } else {
          this.imageTypeConfig.invMoneyTotal = false
          this.imageTypeConfig.invoicesButton = false
          this.imageTypeConfig.invoicesForm = false
        }
        result = result[0]
        for (const key in result) {
          this.form[key] = result[key]
        }
      } else {
        this.imageTypeConfig.invMoneyTotal = false
        this.imageTypeConfig.invoicesButton = false
        this.imageTypeConfig.invoicesForm = false
        this.form = {
          edocNo: '',
          edocType: '',
          edocImageType: '',
          id: '',
          invCode: '',
          invNo: '',
          invDate: '',
          invAmount: 0,
          invTax: 0,
          total: 0,
          kind: '',
          type: '',
          priceSum: 0,
          taxSum: 0,
          totalSum: 0,
          salerName: '',
          salerTaxCode: '',
          buyerName: '',
          buyerTaxCode: '',
          machineCode: '',
          checkCode: '',
          checkDetails: '',
        }
        this.tableData1 = []
      }
      let state = this.modesTaskData
      this.form.edocNo = state.bizCode
      this.form.edocType = state.bizName
      this.form.edocImageType = docId
    },
    // 获取文件类型
    async papperStatus() {
      let state = this.modesTaskData
      let aa = {
        费用报销: 7,
        采购结算: 8,
        资料存档: 9,
        合同存档: 10,
      }
      let processType = { processType: aa[state.bizName] }
      const genList = Object.assign(processType, {
        token: store.get('onlyToken'),
      })
      const { data } = await apiAxios.post(
        '/edoc/edocHeaderFacade/edocHeaderCombobox',
        genList
      )
      this.papperList = data.result.combobox
    },
    async bizType() {
      let processType = { processType: 1 }
      const genList = Object.assign(processType, {
        token: store.get('onlyToken'),
      })
      const { data } = await apiAxios.post(
        '/edoc/edocHeaderFacade/edocHeaderCombobox',
        genList
      )
      this.bizTypeList = data.result.combobox
    },

    async setImages() {
      let state = this.modesTaskData
      const coverId = this.modesTaskData.coverId
      if (state) {
        this.form.edocNo = state.bizCode
        this.form.edocType = state.bizName
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') },
          this.pageTure
        )
        const { data } = await apiAxios.post(
          `/edoc/edocHeaderFacade/edocHeaderDetails1`,
          genList
        )
        this.genPage = data.result.totalElements
        this.viewByPage = data.result.viewByPage
        this.pageTure.viewImageLimit = data.result.viewImageLimit
        this.pageTure.viewImagePage = data.result.viewImagePage
        this.tableData2 = data.result.datagrid //模式二表身信息
        this.imagesUrl = []
        this.imageData = []
        this.imageIndex = 0
        this.curPage = this.imageIndex + 1
        if (data.success) {
          let resArr = data.result.datagrid
          let arr = resArr.map(value => {
            this.imageData.push(value.json)
            this.imagesUrl.push(value.path) //模式三图片的路径
            // value.path = '1.jpg'
            // value.json ? this.imageData.push(JSON.parse(value.json)):this.imageData.push('')
            delete value.json
            return value
          })
          this.images = arr
          this.toSetTaskDetails()
        } else {
          this.$alert(data.msg, '错误提示', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('请选择想要的查看的单据！', '错误提示', {
          confirmButtonText: '确定',
        })
      }
    },

    //模式二
    //删除附件
    async enclsDelete(index, rows) {
      this.$confirm('您确认删除吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger',
      }).then(
        async () => {
          let id = rows.id.toString()
          const { data } = await apiAxios.post(
            '/edoc/edocImageFacade/deleteBillImageById',
            {
              imageId: id,
            }
          )
          this.$alert(data.msg, '操作提示', {
            confirmButtonText: '确定',
          })
          await this.setImages()
          await this.footdata()
        },
        () => {}
      )
    },
    //上传传参
    encParameter() {
      let state = this.modesTaskData
      const coverId = this.modesTaskData.coverId
      this.parameter = {
        taskId: coverId,
        token: store.get('onlyToken'),
      }
      this.parameter2 = {
        taskId: coverId,
        edocImageType: '1001',
        token: store.get('onlyToken'),
      }
      this.parameter3 = {
        taskId: coverId,
        edocImageType: 'BANK_TICKET',
        token: store.get('onlyToken'),
      }
    },
    //提交  （异常或评价都是未封单的，未加处理）
    async onSubmit() {
      this.form.id = this.form.id.toString()
      this.form.edocImageId = this.form.edocImageId.toString()
      this.form.invAmount = this.form.invAmount.toString()
      this.form.invTax = this.form.invTax.toString()
      this.form.edocImageId = this.form.edocImageId.toString()
      // this.form.id = this.form.id.toString()
      const genList = Object.assign(this.form, {
        token: store.get('onlyToken'),
      })
      const { data } = await apiAxios.post(
        `/edoc/invoiceFacade/updateInv`,
        genList
      )
      this.$alert(data.msg, '操作提示', {
        confirmButtonText: '确定',
      })
      await this.invoiceData()
    },
    handleClick(row) {
      console.log(row)
    },
    upSuccess(response, file, fileList) {
      if (response.success) {
        this.$alert(response.msg)
        this.isLoading = false
        this.setImages()
        this.footdata()
      } else {
        this.$alert(response.msg)
        this.isLoading = false
      }
    },
    upError(file, fileList) {
      this.$alert('上传失败', '操作提示', {
        confirmButtonText: '确定',
      })
    },
    handlePreview(file) {
      console.log(file)
    },
    searchMore() {
      this.show = !this.show
    },
    //表头信息
    async tabdata() {
      let state = this.modesTaskData
      if (state) {
        this.headForm.edocNo = state.bizCode
        const genList = Object.assign(
          this.queryParams,
          { edocNo: this.headForm.edocNo },
          { token: store.get('onlyToken') }
        )
        const { data } = await apiAxios.post(
          // `/edoc/edocHeaderFacade/edocHeaderDataGrid`,
          `/edoc/edocHeaderFacade/edocHeaderCheck`,
          genList
        )
        const resData = data
        this.headForm = resData.result.dataGrid[0]
        if (resData.result.dataGrid[0]) {
          this.headForm = resData.result.dataGrid[0]
        } else {
          this.headForm = {
            edocNo: state.bizCode,
            edocType: '',
            seal: '',
            review: '',
            createBy: '',
            imageState: '',
            collectionFrom: '',
            makeEdocNumber: '',
            createTimeStr: '',
            edocTaskStatus: '',
          }
        }
      } else {
        this.$alert('请选择想要的查看的单据！', '错误提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.push({ path: '/pageWeb/ImageAbnormal/ImageAbnormal' })
          },
        })
      }
    },
    // 表身信息
    async footdata() {
      let state = this.modesTaskData
      const coverId = this.modesTaskData.coverId
      if (state) {
        this.form.edocNo = state.bizCode
        this.form.edocType = state.bizName
        const genList = Object.assign(
          { taskId: coverId },
          { token: store.get('onlyToken') }
        )
        const { data } = await apiAxios.post(
          `/edoc/edocHeaderFacade/edocHeaderDetails`,
          genList
        )
        this.tableData2 = data.result.datagrid //模式二表身信息
      } else {
        this.$alert('请选择想要的查看的单据！', '错误提示', {
          confirmButtonText: '确定',
          callback: () => {
            this.$router.push({ path: '/pageWeb/ImageAbnormal/ImageAbnormal' })
          },
        })
      }
    },
    getImages() {
      this.$store.state.taskId
    },
    //模式三

    //模式四
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    watchDoalogBtn() {
      this.watchVisible = false
      this.invoiceData()
    },
    // 模式四发票数据详情
    async watchClick(row) {
      this.watchVisible = true
      this.editItem = Object.assign({}, row)
      this.invDetail = this.editItem.invoiceItemModelList
      let id = row.id.toString()
      let params = {
        invoiceId: id,
        token: store.get('onlyToken'),
      }
      const { data } = await apiAxios.post(
        '/edoc/invoiceFacade/invoiceImage',
        params
      )
      if (data.success == true) {
        this.imgUrl = data.result
      } else {
        this.$alert(data.msg, '错误提示', {
          confirmButtonText: '确定',
        })
      }
    },
    //平台验真
    async checkTrue() {
      let rowDetail = this.$refs.singleTable.store.states.selection
        .map(item => item.id)
        .map(item => item.toString())
      if (rowDetail == '') {
        this.$message({
          showClose: true,
          message: '请勾选需平台验真发票数据',
          type: 'error',
        })
      } else {
        // this.dialogVisible = true
        this.$confirm('您确认平台验真吗？', '验真确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger',
        }).then(
          async () => {
            let rowDetail = this.$refs.singleTable.store.states.selection
              .map(item => item.id)
              .map(item => item.toString())
            let params = {
              invoiceIds: rowDetail,
              token: store.get('onlyToken'),
            }
            this.isLoading = true
            const { data } = await apiAxios.post(
              '/edoc/invoiceFacade/checkReal',
              params
            )
            if (data.success == true) {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success',
              })
              this.invoiceData()
              this.isLoading = false
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error',
              })
            }
          },
          () => {}
        )
      }
    },
    //人工处理
    async manualHandl() {
      let rowDetail = this.$refs.singleTable.store.states.selection
        .map(item => item.id)
        .map(item => item.toString())
      if (rowDetail == '') {
        this.$message({
          showClose: true,
          message: '请勾选需人工处理发票数据',
          type: 'error',
        })
      } else {
        // this.dialogVisible2 = true
        this.$confirm('您确认更改验真结果为真票？', '人工确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger',
        }).then(
          async () => {
            let rowDetail = this.$refs.singleTable.store.states.selection
              .map(item => item.id)
              .map(item => item.toString())
            let params = {
              invoiceIds: rowDetail,
              token: store.get('onlyToken'),
            }
            this.isLoading = true
            const { data } = await apiAxios.post(
              '/edoc/invoiceFacade/checkRealManual',
              params
            )
            if (data.success == true) {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success',
              })
              this.invoiceData()
              this.isLoading = false
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'error',
              })
            }
          },
          () => {}
        )
      }
    },
    //模式四发票数据
    async invoiceData() {
      this.isLoading = true
      let state = this.modesTaskData
      const coverId = this.modesTaskData.coverId.toString()
      if (state) {
        const taskId = { taskId: coverId }
        const genList = Object.assign(
          this.queryParams,
          this.queryResult,
          { token: store.get('onlyToken') },
          taskId
        )
        const { data } = await apiAxios.post(
          `/edoc/invoiceFacade/invoceDataGrid`,
          genList
        )
        if (data.success) {
          this.tableDatalist = data.result.dataGrid
          this.queryResult.totalElements = data.result.totalRows
          this.queryResult.totalPages = Math.ceil(
            this.queryResult.totalElements / this.queryParams.limit
          )
        } else {
          this.$alert(data.msg, '错误提示', {
            confirmButtonText: '确定',
          })
        }
      } else {
        this.$alert('请选择想要的查看的单据！', '错误提示', {
          confirmButtonText: '确定',
        })
      }
      this.isLoading = false
    },
    //编辑
    canEditbut() {
      this.canEdit = false
    },
  },

  async mounted() {
    if (
      this.modesTaskData.bizName == '合同存档' ||
      this.modesTaskData.bizName == '资料存档'
    ) {
      this.modeFour = false
    } else {
      this.modeFour = true
    }
    await this.papperStatus()
    await this.bizType()
    await this.setImages()
    // await this.tabdata()
    await this.footdata()
    await this.invoiceData()
    await this.tabdata()
    await this.change()
    this.encParameter()
    this.endPage = this.pageTure.viewImageLimit
    window.onresize
  },
}
